import React from "react";

const MainButton = ({ onClick, label, className = "", selectState = false }) => {
  return (
    <button
      type="submit"
      onClick={onClick}
      className={`inline-flex h-10 items-center justify-center rounded-xl px-5 text-sm font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-teal-400/40 active:scale-[0.97] ${
        selectState
          ? "bg-gradient-to-r from-teal-500 to-cyan-500 text-white shadow-md shadow-teal-500/30"
          : "bg-white text-main-subfont border border-main-border hover:border-teal-400/60 hover:text-brand-teal hover:bg-teal-500/5"
      } ${className}`}
    >
      <span>{label}</span>
    </button>
  );
};

export default MainButton;
